export function setClipboard(value: string) {
  navigator.clipboard.writeText(value);
}
